// extracted by mini-css-extract-plugin
export default {"root":"LOMZY","icon":"_2o-nH","title":"_3FMeR","subtitle":"_2gZnT","button":"pJxvF"};